/* eslint-disable filename-export/match-default-export */
import yaml from 'js-yaml';

export default function getDataFromFile(extension, fileData) {
  if (extension === 'yaml' || extension === 'yml') {
    return yaml.load(fileData);
  }

  if (extension === 'json') {
    return JSON.parse(fileData);
  }
}
